import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { API_URL } from "../../lib/utils";

const FIELDS = [
  ["full_name", "Nome completo (como no recibo)", "text", "Ex.: João Manuel da Silva"],
  ["position", "Cargo / Função", "text", "Ex.: Empregado de mesa"],
  ["department", "Departamento", "text", "Ex.: Sala"],
  ["inss_number", "Nº Beneficiário INSS", "text", "Ex.: 012345678"],
  ["nif", "NIF do trabalhador", "text", "Ex.: 005123456LA041"],
  ["hire_date", "Data de admissão", "date", ""],
  ["bank_iban", "IBAN (pagamento por transferência)", "text", "AO06 0000 0000 0000 0000 0000 0"],
];
// Horário e penalizações próprios — vazio = regras da empresa (Definições › Empresa › Horário)
const SCHEDULE_FIELDS = [
  ["work_start", "Hora de entrada própria", "time", ""],
  ["work_end", "Hora de saída própria", "time", ""],
  ["absence_deduction", "Valor por falta (Kz)", "number", "regra da empresa"],
  ["late_deduction", "Valor por atraso (Kz)", "number", "regra da empresa"],
];
const NUMERIC = ["absence_deduction", "late_deduction"];

export const EmployeeProfileDialog = ({ open, onOpenChange, employee, headers, onSaved }) => {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && employee) setForm({ ...Object.fromEntries([...FIELDS, ...SCHEDULE_FIELDS].map(([k]) => [k, employee[k] ?? ""])), track_attendance: employee.track_attendance !== false });
  }, [open, employee]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form };
      NUMERIC.forEach((k) => { payload[k] = payload[k] === "" || payload[k] == null ? null : Number(payload[k]); });
      await axios.put(`${API_URL}/hr/employees/${employee.user_id}/hr-profile`, payload, { headers, withCredentials: true });
      toast.success("Dados RH atualizados");
      onOpenChange(false); onSaved?.();
    } catch (err) { toast.error(err.response?.data?.detail || "Erro ao guardar"); }
    finally { setSaving(false); }
  };

  const field = ([k, label, type, ph]) => (
    <div key={k} className="space-y-1">
      <Label className="text-xs">{label}</Label>
      <Input type={type} value={form[k] ?? ""} placeholder={ph} min={type === "number" ? 0 : undefined} step={type === "number" ? "0.01" : undefined} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`hr-profile-${k}`} />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="hr-profile-dialog">
        <DialogHeader><DialogTitle>Dados RH — {employee?.full_name || employee?.name}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <p className="text-xs text-muted-foreground">Estes dados aparecem no recibo de vencimento. O Nº de beneficiário do INSS é obrigatório por lei.</p>
          {FIELDS.map(field)}
          <div className="rounded-lg border p-3 space-y-3" data-testid="hr-profile-schedule">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium">Controlo de faltas e atrasos</p>
                <p className="text-xs text-muted-foreground">Desligue para sócios ou quem não tem horário fixo</p>
              </div>
              <Switch checked={form.track_attendance !== false} onCheckedChange={(v) => setForm({ ...form, track_attendance: v })} data-testid="hr-profile-track_attendance" />
            </div>
            <div className="grid grid-cols-2 gap-2">{SCHEDULE_FIELDS.map(field)}</div>
            <p className="text-[11px] text-muted-foreground">Vazio = usa o horário e os valores definidos para a empresa.</p>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={saving} data-testid="save-hr-profile-btn">{saving ? "A guardar..." : "Guardar"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
